import _ from 'lodash'
import { useMemo } from 'react'
import { SwiperSlide } from 'swiper/react'

import { gEnums } from 'global/enums/globalEnums'

import { uniqueKey } from 'global/common/keys'
import { _swiperMenuTypes } from './SwiperMenu'
import { Swiper_Any } from './Swiper_Any'

export const Swiper_PageItem = ({
  swKey,
  itemElements,
  groupDataProps,
  swipeContentType,
  swiperMenuType = _swiperMenuTypes.menu,
  isChild = true,
  applyFade = false,
}) => {

  const slides = useMemo(() => {
    if (swipeContentType !== gEnums.swipeContentTypes.groupedItems || _.isEmpty(itemElements)) return []
    return _.map(itemElements, (elem, csiKey, idx) => (
      <SwiperSlide key={uniqueKey('sipi', csiKey)}>
        {elem.content}
      </SwiperSlide>
    ))
  }, [itemElements, swipeContentType])

  return (
    <Swiper_Any
      swKey={swKey}
      menuItems={itemElements}
      groupDataProps={groupDataProps}
      swipeContentType={swipeContentType}
      swiperMenuType={swiperMenuType}
      isChild={isChild}
      applyFade={applyFade}
      slides={slides}
    />
  )
}